module.exports = __webpack_public_path__ + "static/media/imgbt.15190b46.png";